/**
 * Created by DynamicDog on 2016-12-03.
 *
 * A carousel with etiketts.
 */
import {Component,AfterViewInit, ElementRef,Input} from '@angular/core';
import {EtikettService} from "../services/etikett.service";


var $ = window['$'];
@Component({
    selector: 'etikett-carousel',
    template: `  <div class="carousel {{etikettService.shape}}" (reset)="reset()">
                    <etikett class="carousel-item {{etikettService.shape}}" [ngClass]="{clickable: i!==etikett.image}" [ngStyle]="carouselItemStyle" *ngFor="let path of getImagePaths();let i = index" id="slide-{{i}}" [index]="i" (click)="onSelect(i)" [etikett]="etikett"></etikett>
                </div>
                <div style="text-align:center">
                    <img *ngFor="let path of getImagePaths();let i = index" class="etikett-thumbnail clickable" [ngClass]="{active: i===etikett.image}" (click)="onSelect(i)" [src]=path>
                </div>
`,
})

export class EtikettCarouselComponent implements AfterViewInit {
    @Input() etikett: any;

    options: any = {
        time_constant: 200,
        dist: -50,
        shift: 0,
        padding: 0,
        no_wrap:true

    }

    timestamp: any;
    amplitude: any;

    target: number;
    offset: number = 0;

    dim: number;

    // The categories and the number of images in each category


    // Paths to all the images. Primarily this is for *ngFor to work correctly
    imagePaths: any = {};

    // Image size of medium patterns.
    imageWidth: number = 179;
    imageHeight: number = 272;

    carouselItemStyle={};
    zOffset = 100;
    yOffset = 400;

    constructor(public elementRef:ElementRef,private etikettService:EtikettService) {
        if(this.etikettService.shape === 'locketikett') {
            this.imageWidth = this.carouselItemStyle['width'] = 379;
            this.options.shift = -10;
            this.zOffset = 50;
            this.yOffset = 300;
        } else {
            this.imageWidth = this.carouselItemStyle['width'] = 379;
            this.options.shift = 0;
            this.zOffset = 0;
            this.yOffset = 400;
        }
        
        
        
        for(let i in this.etikettService.imageCount) {
            this.createImagePaths(i);
        }
        this.dim = this.imageWidth * 2 + this.options.padding;
        var _this = this;
        window.onresize = function(event) {
            _this.resize();
        }
        _this.resize();
    }

    private resize():void {
        
        if(window.innerWidth < 1024) {
            this.zOffset = -20;
        } else {
            if(this.etikettService.shape === 'locketikett') {
                this.zOffset = 40;
            } else {
                this.zOffset = 0;
            }
        }
        if(this.etikett)
            this.warp(this.etikett.image);
    }

    public reset():void {
        
        this.imagePaths = {};
        for(let i in this.etikettService.imageCount) {
            this.createImagePaths(i);
        }
    }

    public refresh():void {
        if(this.etikett) {
            this.warp(this.etikett.image);
        }
    }
    private createImagePaths(mode:string) {
        
        this.imagePaths[mode]=[];
        for (var i = 0; i < this.etikettService.imageCount[mode]; i++) {
            this.imagePaths[mode].push(this.getImagePath(mode,i));
        }
        
    }

    // Construct an image patch based on category and index
    private getImagePath(mode:string,index: number): string {
        return 'labels/'+this.etikettService.shape+'/'+mode+'/pattern-' + index + '-medium.png';
    }

    // Get image paths for the current category
    private getImagePaths() {
        return this.imagePaths[this.etikett.mode];
    }

    // Jump directly to an etikett without scrolling
    public warp(index:number) {

        this.offset = (this.dim * index)-1;
        this.onNext(0);
    }

    // The view is ready, warp to the saved etikett image
    public ngAfterViewInit():void {
        this.warp(this.etikett.image);
    }

    // The user selected an image, do a smooth scroll.
    private onSelect(index: number): void {
        var diff = (this.etikett.image % this.etikettService.imageCount[this.etikett.mode]) - index;

        // Call prev or next accordingly.
        if (diff < 0) {
            this.onNext(-diff);
        } else if (diff > 0) {
            this.onPrev(diff);
        }
    }

    // Scroll toward the beginning
    private onPrev(count: number): void {
        this.target = (this.dim * Math.round(this.offset / this.dim)) - (this.dim * count);
        if (this.offset !== this.target) {
            this.amplitude = this.target - this.offset;
            this.timestamp = Date.now();
            requestAnimationFrame(() => this.autoScroll());
        }
    }

    // Scroll toward the end.
    private onNext(count: number): void {
        this.target = (this.dim * Math.round(this.offset / this.dim)) + (this.dim * count);
        if (this.offset !== this.target) {
            this.amplitude = this.target - this.offset;
            this.timestamp = Date.now();
            requestAnimationFrame(() => this.autoScroll());
        }
    }

    // Scroll animation
    private autoScroll() {
        var elapsed:number;
        var delta:number;

        if (this.amplitude) {
            elapsed = Date.now() - this.timestamp;
            delta = this.amplitude * Math.exp(-elapsed / this.options.time_constant);
            if (delta > 2 || delta < -2) {
                this.scroll(this.target - delta);
                requestAnimationFrame(() => this.autoScroll());
            } else {
                this.scroll(this.target);
            }
        }
    }

    // Move one step
    private scroll(x: number) {
        var i:number;
        var half:number;
        var delta:number;
        var dir:number;
        var tween:number;

        i = 0;
        this.offset = (typeof x === 'number') ? x : this.offset;
        this.etikett.image = Math.floor((this.offset + this.dim / 2) / this.dim);
        delta = this.offset - this.etikett.image * this.dim;
        dir = (delta < 0) ? 1 : -1;
        tween = -dir * delta * 2 / this.dim;
        half = this.etikettService.imageCount[this.etikett.mode] >> 1;

        // Todo: Get correct values
        var div = $(this.elementRef.nativeElement).find('.carousel');
        var divCenterX = (div.width() - this.imageWidth) / 2;
        var divCenterY = (this.yOffset - this.imageHeight) / 2;

        // Translate to the center of the screen.
        var alignment: string = 'translateX(' + divCenterX + 'px) translateY(' + divCenterY + 'px)';

        // Center
        var el = $(this.elementRef.nativeElement).find('#slide-'+this.etikett.image);
        var tweenedOpacity = 1 - 0.2 * tween;

        var transform = alignment +
            ' translateX(' + (-delta / 2) + 'px)' +
            ' translateX(' + (dir * this.options.shift * tween * i) + 'px)' +
            ' translateZ(' + (this.zOffset+(this.options.dist * tween)) + 'px)';

        this.setStyleString(el,0,tweenedOpacity,transform);

        // Sides
        var zTranslation:number;
        for (i = 1; i <= half; ++i) {
            // right side
            zTranslation = this.options.dist * (i * 2 + tween * dir);
            tweenedOpacity = 1 - 0.2 * (i * 2 + tween * dir);

            // Don't show wrapped items.
            if (!this.options.no_wrap || this.etikett.image + i < this.etikettService.imageCount[this.etikett.mode]) {
                transform = alignment +
                    ' translateX(' + (this.options.shift + (this.dim * i - delta) / 2) + 'px)' +
                    ' translateZ(' + (this.zOffset+ zTranslation) + 'px)';

                var el = $(this.elementRef.nativeElement).find('#slide-'+(this.etikett.image+i));
                this.setStyleString(el,-i,tweenedOpacity,transform);
            }


            // left side
            zTranslation = this.options.dist * (i * 2 - tween * dir);
            tweenedOpacity = 1 - 0.2 * (i * 2 - tween * dir);

            // Don't show wrapped items.
            if (!this.options.no_wrap || this.etikett.image - i >= 0) {
                transform = alignment +
                    ' translateX(' + (-this.options.shift + (-this.dim * i - delta) / 2) + 'px)' +
                    ' translateZ(' + (this.zOffset+zTranslation) + 'px)';

                var el = $(this.elementRef.nativeElement).find('#slide-'+(this.etikett.image-i));
                this.setStyleString(el,-i,tweenedOpacity,transform);
            }
        }

        // center
        if (!this.options.no_wrap || (this.etikett.image >= 0 && this.etikett.image < this.etikettService.imageCount[this.etikett.mode])) {

            transform = alignment +
                ' translateX(' + (-delta / 2) + 'px)' +
                ' translateX(' + (dir * this.options.shift * tween) + 'px)' +
                ' translateZ(' + (this.zOffset+(this.options.dist * tween)) + 'px)';
            tweenedOpacity = 1 - 0.2 * tween;


            var el = $(this.elementRef.nativeElement).find('#slide-'+this.etikett.image);
            this.setStyleString(el,0,tweenedOpacity,transform);

        }
    }

    // Create a transformation string for all browsers.
    private getTransformString(transform:string) :string {
        return  '-moz-transform:'+transform +
            ';-webkit-transform:'+ transform +
            ';-o-transform:'+ transform+
            ';-ms-transform:'+ transform+
            ';transform;'+ transform+';';
    }

    // Create and set a transformation and visibility style.
    private setStyleString(element:any,zindex:number,tweenedOpacity:number,transform:string) {
        var strStyle = '';
        if(tweenedOpacity < 0) {
            strStyle = 'display:none;';
        } else {
            strStyle = 'z-index:' + zindex +
                '; opacity:' + tweenedOpacity +
                ';display: block;' +
                this.getTransformString(transform);
        }
        element.attr('style',strStyle);
    }


}


// WEBPACK FOOTER //
// ./app/etikett/etikettcarousel.component.ts